import { apiFetch, readApiJson } from '@/lib/api-fetch'
import { ManufacturerSearchResponseSchema, type ManufacturerSearchItem } from '@/lib/api/schemas/manufacturer-search.schema'

const MANUFACTURER_SEARCH_LIMIT = 20

/** Read-only Forge lookup. A selected identity is the server's stable UUID plus canonical display name. */
export async function searchManufacturers(query: string, signal?: AbortSignal): Promise<ManufacturerSearchItem[]> {
  const normalizedQuery = query.trim()
  if (normalizedQuery.length < 2 || normalizedQuery.length > 120) return []

  const parameters = new URLSearchParams()
  parameters.set('q', normalizedQuery)
  parameters.set('limit', String(MANUFACTURER_SEARCH_LIMIT))
  const response = await apiFetch(`/api/inventory/manufacturers/search?${parameters.toString()}`, { signal })
  const payload = await readApiJson(response)
  return ManufacturerSearchResponseSchema.parse(payload).items
}
